const FacebookIcon = ({color}) => {
  return (
    <svg
      width="38"
      height="37"
      viewBox="0 0 38 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.9519 3.30167C23.8426 3.30167 24.4226 3.31998 26.3551 3.40852C31.3191 3.63443 33.6377 5.98971 33.8636 10.917C33.9521 12.848 33.9689 13.428 33.9689 18.3187C33.9689 23.2109 33.9506 23.7894 33.8636 25.7203C33.6362 30.6431 31.3236 33.0029 26.3551 33.2288C24.4226 33.3174 23.8457 33.3357 18.9519 33.3357C14.0612 33.3357 13.4812 33.3174 11.5503 33.2288C6.5741 33.0014 4.26767 30.6354 4.04176 25.7188C3.95322 23.7879 3.93491 23.2094 3.93491 18.3172C3.93491 13.4265 3.95475 12.848 4.04176 10.9155C4.26919 5.98971 6.58174 3.6329 11.5503 3.40699C13.4827 3.31998 14.0612 3.30167 18.9519 3.30167ZM18.9519 0C13.9773 0 13.3545 0.02137 11.4007 0.109903C4.74849 0.415189 1.05148 4.1061 0.746195 10.7644C0.656136 12.7197 0.634766 13.3425 0.634766 18.3172C0.634766 23.2918 0.656136 23.9161 0.744669 25.8699C1.04995 32.5221 4.74086 36.2191 11.3991 36.5244C13.3545 36.6129 13.9773 36.6343 18.9519 36.6343C23.9266 36.6343 24.5509 36.6129 26.5047 36.5244C33.1508 36.2191 36.8569 32.5282 37.1576 25.8699C37.2477 23.9161 37.2691 23.2918 37.2691 18.3172C37.2691 13.3425 37.2477 12.7197 37.1592 10.7659C36.86 4.11983 33.1645 0.416715 26.5062 0.111429C24.5509 0.02137 23.9266 0 18.9519 0Z"
        fill={color}
      />
      <path
        d="M20.9658 30.5283H15.5512V18.3158H12.8457V14.1076H15.5518V11.5802C15.5518 8.14667 17.0788 6.10547 21.4189 6.10547H25.0324V10.3148H22.7738C21.084 10.3148 20.9726 10.9031 20.9726 12.0007L20.9658 14.107H25.0571L24.5787 18.3152H20.9658V30.5283Z"
        fill={color}
      />
    </svg>
  );
};

export default FacebookIcon;
